import React from 'react'
import { useNavigate } from "react-router-dom";
import { useEffect} from "react";


function Redir() {

    const nav = useNavigate();

    useEffect(() => {
        nav("/");
    }, )

    return ( <></> );
}

export default Redir;